import React from 'react';
import HrbTranslate from "../language/HrbTranslate";
import auth from "../../services/auth/AuthProvider";

const DashboardIntroPanel = (props) => (
  <div>
    <div className="hrb-dashboard-welcome-back-heading">
      <HrbTranslate text="dashboard.welcome_back"/>
    </div>

    <div className="hrb-dashboard-intro-text">
      <HrbTranslate text={auth.isAuthenticated() ? "dashboard.intro_text_authorized" : "dashboard.intro_text_unauthorized"}/>
    </div>
  </div>
);

export default DashboardIntroPanel;
